module.exports = __webpack_public_path__ + "static/img/Portal_Universia.fd2328d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Portal_Universia.png
// module id = lv6n
// module chunks = 1